
import { BusinessUnitEntityDecorator } from '../../businessunit/model/business-unit.decorator';
import { BusinessUnit } from '../../businessunit/model/business-unit.model';
import { SYSTEM_MESSAGE_METADATA } from './system-message.metadata';
import { SystemMessage } from './system-message.model';
import { EntityDecorator, GenericEntityDecorator } from '@scisys-uim/uim-common';


export abstract class SystemMessageEntityDecoratorBase extends GenericEntityDecorator<SystemMessage, number> {
  constructor() {
    super(SYSTEM_MESSAGE_METADATA, {
      get businessUnit(): EntityDecorator<BusinessUnit, string> {
        return new BusinessUnitEntityDecorator();
      }
    }, {
    });
  }
  toKeyObjectFromRouteParams(params: any): number {
    if (params == null || params.id == null) {
      return null;
    }
    return parseInt(params.id);
  }
  toKeyUrlPathSegments(key: number): string {
    if (key == null) {
      return null;
    }
    return '' + key;
  }
  toKeyRouteSegments(item: SystemMessage): any[] {
    const key: number = this.metadata?.toKeyObject(item);
    if (key == null) {
      return null;
    }
    return [key];
  }
}




